import { useGTM } from '~/thirdParty/tracking/GTM';

// NOTE: https://support.karte.io/post/ALVPd86B5a3m4Gjj6Q7hq
export const useKarteViewEvent = () => {
  const { sendToGTM } = useGTM();
  const sendKarteViewEvent = () => {
    sendToGTM({ event: 'NAVIGATION_HISTORY_CHANGED' });
  };

  return sendKarteViewEvent;
};
